import AuthProvider from './AuthProvider';

export default class AuthService {
  getLogoutSuccessUrl() {
    return AuthProvider.getLogoutSuccessUrl();
  }

  set(data) {
    return AuthProvider.set(data);
  }

  static build(args) {
    return new AuthService(args);
  }
}
